module.exports = __webpack_public_path__ + "static/key-warstone-1e32b3c180a00fe7395d6836fda422ac.webp";